module.exports = __webpack_public_path__ + "img/title.3f8cc427.png";